import { render, staticRenderFns } from "./StepsColumn.vue?vue&type=template&id=67f07ef2&scoped=true"
import script from "./StepsColumn.vue?vue&type=script&lang=js"
export * from "./StepsColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f07ef2",
  null
  
)

export default component.exports